"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Svg(_ref) {
  var styles = _ref.styles;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: styles
  }, /*#__PURE__*/_react.default.createElement("circle", {
    opacity: "0.8",
    cx: "50",
    cy: "50",
    r: "50",
    fill: "#A6D4FF"
  }), /*#__PURE__*/_react.default.createElement("g", {
    opacity: "0.5"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M51.1825 42.9324L42.933 51.182C42.4123 51.7027 42.4123 52.5469 42.933 53.0676C43.4537 53.5883 44.2979 53.5883 44.8186 53.0676L53.0682 44.818C53.5889 44.2973 53.5889 43.4531 53.0682 42.9324C52.5475 42.4117 51.7032 42.4117 51.1825 42.9324Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M53.0684 51.182L44.8188 42.9324C44.2981 42.4117 43.4539 42.4117 42.9332 42.9324C42.4125 43.4531 42.4125 44.2973 42.9332 44.818L51.1827 53.0676C51.7034 53.5883 52.5477 53.5883 53.0684 53.0676C53.5891 52.5469 53.5891 51.7027 53.0684 51.182Z",
    fill: "white",
    stroke: "white"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56.3055 63.9445C55.2315 62.8706 55.2315 61.1294 56.3055 60.0555C57.3794 58.9815 59.1206 58.9815 60.1945 60.0555L71.1945 71.0555C72.2685 72.1294 72.2685 73.8706 71.1945 74.9445C70.1206 76.0185 68.3794 76.0185 67.3055 74.9445L56.3055 63.9445Z",
    fill: "#091E42"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.25 62C54.8439 62 61 55.8439 61 48.25C61 40.6561 54.8439 34.5 47.25 34.5C39.6561 34.5 33.5 40.6561 33.5 48.25C33.5 55.8439 39.6561 62 47.25 62ZM47.25 67.5C36.6185 67.5 28 58.8815 28 48.25C28 37.6185 36.6185 29 47.25 29C57.8815 29 66.5 37.6185 66.5 48.25C66.5 58.8815 57.8815 67.5 47.25 67.5Z",
    fill: "#091E42"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "63",
    cy: "33",
    r: "10",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2528 37.9802C62.2528 38.7263 63.2239 39.0148 63.6312 38.3896L67.1679 32.9615C67.4929 32.4626 67.1349 31.8021 66.5395 31.8021H63.6705V28.525C63.6705 27.7788 62.6994 27.4904 62.2921 28.1156L58.7554 33.5437C58.4304 34.0426 58.7884 34.7031 59.3838 34.7031H62.2528V37.9802Z",
    fill: "#E01E5A"
  }));
}

var _default = Svg;
exports.default = _default;